import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
    query AllVendors {
        allDatoCmsVendor {
            edges {
                node {
                    ...VendorFields
                }
            }
        }
    }
`;

export const useAllVendors = (): Queries.VendorFieldsFragment[] => {
    
    const data = useStaticQuery<Queries.AllVendorsQuery>(query);

    return data.allDatoCmsVendor.edges.map(({ node: vendor }) => {
        return vendor as Queries.VendorFieldsFragment;
    });
};